export default __webpack_public_path__ + "static/media/booking-blue.1fd1a797.svg";